import configurl from '@/config/user.env';
import { importApi, exportApi } from '@/modules/mdm/api/targetModdeules/subMissionApplication.js';

export const importConfigOpt = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: exportApi,
    importApi: importApi,
    downParams: {
        fileName: '目标对象导入模板.xlsx',
        fileId: 'goalMonthlyProgressAddImport.xlsx'
    },
    multiple: false,
    accept: '.xlsx,.xls',
    limtSizeKey: 'goalMainImport',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    downloadTip: '请稍后到右上角用户文件列表中下载',
    manualUpload: true
};
